import * as React from 'react';

import './CategoriesMobileSubmenu.scss';
import { goToCategory } from 'src/utils/navigation';
import installation from 'src/assets/installationIconSidemenu';
import tools from 'src/assets/toolsIconSidemenu';
import hvac from 'src/assets/hvacIconSidemenu';
import filters from 'src/assets/filtersIconSidemenu';
import cleaners from 'src/assets/cleanersIconSidemenu';
import brushes from 'src/assets/brushIconSideMenu';
import flashlights from 'src/assets/flashlightsIconSidemenu';
import aircondtioner from 'src/assets/airConditionerIconSidemenu';
import hoseIcon from 'src/assets/hoseIconSidemenu';
import protectiveIcon from 'src/assets/protectiveSidemenu';
import applianceIcon from 'src/assets/applianceSidemenu';
import smallapplianceIcon from 'src/assets/smallAppliancesSidemenu';
import garburatorIcon from 'src/assets/garburatorsSidemenu';
import homeCareIcon from 'src/assets/homecareSidemenu';
import i18n from 'src/translation/i18n';
import training from 'src/assets/mortarboardSidemenu';

interface ICategoriesMobileSubmenuState {
  show: boolean;
  showSubcategories: boolean;
  subcategories: any;
  subMenuTitle: string;
  style: object;
}

interface ICategoriesMobileSubmenuProps {
  mounted: boolean;
  goBackTitle: string;
  menuTitle: string;
  level: number;
  categories: any[];
  handleCloseMenu: () => void;
  handleCloseAll: () => void;
}

class CategoriesMobileSubmenu extends React.Component<
  ICategoriesMobileSubmenuProps,
  ICategoriesMobileSubmenuState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      showSubcategories: false,
      subcategories: [],
      subMenuTitle: '',
      style: {
        transform: 'translateX(0vw)',
        transition: 'transform 200ms ease-in'
        // height: this.calcHeight()
      }
    };
  }

  public componentWillReceiveProps(newProps: any) {
    if (!newProps.mounted) {
      return this.unMountStyle();
    }
    this.setState({
      show: true
    });
    setTimeout(this.mountStyle, 10);
  }

  public unMountStyle = () => {
    this.setState({
      style: {
        transform: 'translateX(-100vw)',
        transition: 'transform 200ms ease-in'
        // height: this.calcHeight()
      }
    });
  };

  public mountStyle = () => {
    this.setState({
      style: {
        transform: 'translateX(0vw)',
        transition: 'transform 200ms ease-out',
        zIndex: this.props.level
        // height: this.calcHeight()
      }
    });
  };

  public categoryIcon = [
    { category: 'installation', imageSrc: installation },
    { category: 'appliance parts', imageSrc: applianceIcon },
    { category: 'tools', imageSrc: tools },
    { category: 'Tools & Protective Wear', imageSrc: protectiveIcon },
    { category: 'hvac', imageSrc: hvac },
    { category: 'Garburators', imageSrc: garburatorIcon },
    { category: 'filters', imageSrc: filters },
    { category: 'Home Care Products', imageSrc: homeCareIcon },
    { category: 'cleaners', imageSrc: cleaners },
    { category: 'cleaning', imageSrc: cleaners },
    { category: 'brushes', imageSrc: brushes },
    { category: 'Small Appliances & Parts', imageSrc: smallapplianceIcon },
    { category: 'flashlights', imageSrc: flashlights },
    { category: 'Hoses, Connectors & Fittings', imageSrc: hoseIcon },
    { category: 'a/c', imageSrc: aircondtioner },
    { category: 'Training Classes', imageSrc: training }
  ];

  public transitionEnd = () => {
    if (!this.props.mounted) {
      this.setState({
        show: false
      });
    }
  };

  public handleOpenSubMenu = (category: any) => {
    this.setState({
      showSubcategories: true,
      subcategories: category.subcategories,
      subMenuTitle: category.name
    });
    this.handleOpenSubCategory(category);
  };

  public handleCloseSubMenu = () => {
    this.setState({
      showSubcategories: false
    });
  };

  public handleOpenSubCategory = (subcategory: any) => {
    if (subcategory.subcategories != null) {
      // Ignore categories
      return;
    }
    this.props.handleCloseAll();
    goToCategory(subcategory.category.id, subcategory.id);
  };

  // private calcHeight = (): number => {
  //   const searchbar = document.getElementsByClassName('rp-searchbar-header')[0];
  //   if (searchbar == null) {
  //     return null;
  //   }
  //   const searchbarRect = searchbar.getBoundingClientRect();
  //   const windowHeight = window.innerHeight;
  //   return windowHeight - searchbarRect.bottom;
  // };
  public goToCategory = (categoryId: number, subcategoryId: number) => {
    goToCategory(categoryId, subcategoryId);
    this.setState({
      // showMenu: false
    });
  };
  public render() {
    return (
      this.state.show && (
        <div
          style={this.state.style}
          onTransitionEnd={this.transitionEnd}
          className="rp-categories-mobile-submenu roboto"
        >
          <div
            onClick={e => this.props.handleCloseMenu()}
            className="rp-categories-mobile-submenu--go-back-title"
          >
            <button className="rpds-chevron-left go-back-arrow-icon" />
            <span className="go-back-title">{this.props.goBackTitle}</span>
          </div>
          <div className="rp-category-mobile--menu-title">
            {this.props.menuTitle}
          </div>
          <div className="rp-category-mobile--categories">
            {this.props.categories && this.props.categories.length > 0 ? (
              this.props.categories.map(category => (
                <div
                  className="rp-category-mobile--category"
                  key={category.id}
                  onClick= {() => {category.name === 'Training Classes'?this.goToCategory(62,62) :
            this.handleOpenSubMenu(category)}}
                >
                  {category.subcategories ? (
                    <div
                      className="rp-category-mobile--category-with-arrow"
                      onClick= {() => {category.name === 'Training Classes'?this.goToCategory(62,62) :
            this.handleOpenSubMenu(category)}}
                    >
                      <div className="rp-mobile-category-main-container" role="button" tabIndex={category.orderNumber} onClick= {() => {category.name === 'Training Classes'?this.goToCategory(62,62) :
            this.handleOpenSubMenu(category)}}>
                        <img
                          className="rp-mobile-category-icon"
                          src={
                            this.categoryIcon.find(
                              img =>
                                img.category.toLowerCase() ===
                                category.name.toLowerCase()
                            )?.imageSrc
                          }
                        />
                        <div className="rp-mobile-category-name">
                          {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && category.frName!== null 
                          ?category.frName
                          :category.name}
                        </div>
                      </div>
                      <div className='arrow-div'>
                      <button className="rpds-chevron-right submenu-arrow-icon" />
                      </div>
                    </div>
                  ) : (
                    <button className="sub-rp-category-mobile--category-button" >
                      {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && category.frName!== null 
                          ?category.frName
                          :category.name}
                      </button>
                  )}
                </div>
              ))
            ) : (
              <div className="rp-category-mobile--category">
                {i18n.t('common.noCategoriesFound')}
              </div>
            )}
          </div>
          <div className="rp-categories-submenu-list">
            <CategoriesMobileSubmenu
              mounted={this.state.showSubcategories}
              goBackTitle={i18n.t('common.backtoMainMenu')}
              menuTitle={this.state.subMenuTitle}
              level={this.props.level + 1}
              categories={this.state.subcategories}
              handleCloseMenu={this.handleCloseSubMenu}
              handleCloseAll={this.props.handleCloseAll}
            />
          </div>
        </div>
      )
    );
  }
}

export default CategoriesMobileSubmenu;
